import { Component, ElementRef, Inject, OnDestroy, OnInit, Renderer2, ViewChild, ViewContainerRef } from '@angular/core';
import { GoldenLayoutContainerInjectionToken, WidgetHostDirective } from '../../../_directives/widget-host.directive';
import { ComponentContainer } from 'golden-layout';
import { Store } from '@ngrx/store';
import { MainStoreState } from '../../../_store/mainStoreState';
import { GridWrapper } from '../../../_models/GridWrapper';
import { Avancement } from '../../../_models/Avancement';
import { loadAvancementsAction, selectAllAvancements, selectAvancementsByEs } from '../../../_store/AvancementStore/avancement.store';
import { AvancementService } from '../../../_services/http/avancement.service';
import { GridComponent, GroupKey, GroupRowArgs } from '@progress/kendo-angular-grid';
import { IEvenementSpontane } from '../../../_models/EvenementSpontane';
import { distinct } from '@progress/kendo-data-query';

@Component({
  selector: 'app-widget-avancement-list',
  templateUrl: './avancement-list.component.html',
  styleUrls: ['./avancement-list.component.scss'],
})
export class AvancementListComponent extends WidgetHostDirective implements OnInit, OnDestroy {
  @ViewChild('kendoGrid', { static: true }) kendoGrid!: GridComponent;

  // Grid attributes
  public gridWrapper!: GridWrapper<Avancement>;
  expandedGroupKeys: GroupKey[] = [];
  initiallyExpanded = false;

  private channel = new BroadcastChannel('avancement-list');

  constructor(
    @Inject(GoldenLayoutContainerInjectionToken) container: ComponentContainer,
    elRef: ElementRef,
    renderer: Renderer2,
    viewContainerRef: ViewContainerRef,
    store: Store<MainStoreState>,
    public crudService: AvancementService
  ) {
    super(container, elRef.nativeElement, renderer, viewContainerRef, store);

    this.channel.addEventListener('message', (evt: MessageEvent<IEvenementSpontane>) => {
      this.config.item = evt.data;
      if (evt.data) {
        this.gridWrapper.reload(this.store.select(selectAvancementsByEs(evt.data)));
      }
    });
  }

  ngOnInit(): void {
    const filters: any = {
      logic: 'or',
      filters: [
        {
          field: 'nomSousSysteme',
          operator: 'contains',
        },
        {
          field: 'nomEquipement',
          operator: 'contains',
        },
        {
          field: 'numeroPgm',
          operator: 'contains',
        },
        {
          field: 'message',
          operator: 'contains',
        },
      ],
    };
    const obs = this.config.item ? this.store.select(selectAvancementsByEs(this.config.item)) : this.store.select(selectAllAvancements);

    this.gridWrapper = new GridWrapper<Avancement>('Avancement', obs, filters, this.kendoGrid);
    this.gridWrapper.gridState.take = undefined;
    this.gridWrapper.gridState.skip = undefined;
    this.gridWrapper.gridState.group = [
      {
        field: 'numeroPgm',
        dir: 'asc',
        aggregates: [{ field: 'progress', aggregate: 'min' }],
      },
      {
        field: 'nomSousSysteme',
        dir: 'asc',
        aggregates: [{ field: 'progress', aggregate: 'min' }],
      },
    ];

    this.store.dispatch(loadAvancementsAction({ force: false }));
    this.crudService.refreshHubConnection();
  }

  ngOnDestroy(): void {
    this.gridWrapper.destroy();
  }

  reload(): void {
    this.store.dispatch(loadAvancementsAction({ force: true }));
  }

  isGroupExpanded = (rowArgs: GroupRowArgs): boolean => {
    if (rowArgs.group?.field === 'numeroPgm') {
      return true;
    }

    return this.expandedGroupKeys.some(
      (groupKey) => groupKey.field === rowArgs.group?.field && groupKey.value === rowArgs.parentGroup?.groupIndex + rowArgs.group.value
    );
  };

  toggleGroup(rowArgs: GroupRowArgs): void {
    if (rowArgs.group) {
      const keyIndex = this.expandedGroupKeys.findIndex(
        (groupKey) => groupKey.field === rowArgs.group?.field && groupKey.value === rowArgs.parentGroup?.groupIndex + rowArgs.group.value
      );

      if (keyIndex === -1) {
        this.expandedGroupKeys.push({
          field: rowArgs.group.field,
          value: rowArgs.parentGroup?.groupIndex + rowArgs.group.value,
        });
      } else {
        this.expandedGroupKeys.splice(keyIndex, 1);
      }
    }
  }

  removeFilterByEs() {
    this.gridWrapper.reload(this.store.select(selectAllAvancements));
    this.config.item = null;
  }

  public distinctPrimitive(fieldName: string): unknown[] {
    return distinct(this.gridWrapper.internalData, fieldName).map(
      // @ts-ignore
      (item) => item[fieldName]
    );
  }
}
